import { UserRole } from 'context/user/userContext/UserContext.types';

export type HomeProps = {
  onLogin: () => Promise<void>;
  onLoginWithBebatRole?: () => Promise<void>;
  onLoginWithRole?: (role: UserRole) => Promise<void>;
  onLoginWithKey?: (values: { key: string }) => Promise<void>;
  showRegister: boolean;
  isLoading: boolean;
  errorMessageId?: string;
};

export enum LoginScreens {
  LOGIN_OPTIONS,
  KEY,
  ACCOUNTS,
}
